import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import ConfigContext from '../../../contexts/ConfigContext';

import styles from './Search.module.postcss';
import EventDetails from '../events/EventDetails';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.tz.setDefault('America/Los_Angeles');

function SearchEvent({ event, booking: { truck }, onMouseEnter, onMouseLeave }) {
  const { imageBase } = useContext(ConfigContext);
  const history = useHistory();

  const categories = truck.food_categories_string;
  const truckUrl = `/food-trucks/${truck.id}`;

  let image = '/static/images/truck-placeholder.png';
  if (truck.featured_photo) {
    image = `${imageBase}/${truck.featured_photo}`;
  }

  return (
    <div className={styles.SearchEvent} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Link to={truckUrl} target="_blank" rel="noopener noreferrer">
        <div
          className={styles.SearchEvent_Image}
          style={{
            backgroundImage: `url("${image}")`
          }}
        />

        <div className={styles.SearchEvent_Info}>
          <div className={styles.SearchEvent_Info__inner}>
            <div className={styles.SearchEvent_Name}>{truck.name}</div>
            <div className={styles.SearchEvent_Categories}>{categories}</div>
            <EventDetails
              event={event}
              address={event.address}
              showBadges
              vehicleType={truck.vehicle_type}
              establishedYear={truck.established_year}
            />
          </div>

          <div className={styles.SearchEvent_Menu}>
            <button
              type='button'
              className='Button Button--outlined'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                history.push(truckUrl + '#menu');
              }}
            >
              View Menu
            </button>
          </div>
        </div>

      </Link>
    </div>
  );
}

SearchEvent.propTypes = {
  event: PropTypes.object.isRequired,
};

export default SearchEvent;
